export function isTwoTariffValue(inputResult) {
    return inputResult.tariff === 'Zweitarif';
}
